import styled from 'styled-components';

import { ColumnContent } from 'styles/ColumnContent';

export const CustomColumnContent = styled(ColumnContent)`
    margin-bottom: 3rem;
`;

export const HelpBlockTitle = styled.p`
    color: var(--main-color);
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
`;

export const HelpBlockText = styled.p`
    line-height: 150%;
    margin-bottom: 1.75rem;
`;
